import React from 'react';
import ActionButton from '../../action-button';
import { useEditorHeaderContext } from '../context';

const UpgradeButton = ({ label, ...props }) => {
  const { isLg } = useEditorHeaderContext();

  return (
    <div className="ws-ui-editor-header__upgrade-btn">
      <ActionButton
        {...props}
        label={isLg ? label : undefined}
        iconPlacement="before"
        iconGlyph={isLg ? undefined : 'upgrade'}
        format="solid"
        size="small"
        appearance="cta"
      />
    </div>
  );
};

export default UpgradeButton;
